import { INote } from "../types/INote";

export const buildImportantNote = (note: INote) => {
  if (note.id) {
    return {
      id: note.id,
      title: note.title,
      publicationDate: note.publicationDate,
      urgent: note.urgent,
    };
  }
};

export const getNoteType = (note: INote) => {
  return note.important ? "important" : "normal";
};

export const clearFirstShow = (notes: INote[]) => {
  return notes.map((el) => ({ ...el, firstShow: false }));
};
